import { BasicPersistenceService } from '../../../../../shared/services/BasicPersistenceService';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { AppCalculatorModel } from "../models/AppCalculatorModel";

export class AppPersistenceService extends BasicPersistenceService<IbanAppDefinition> {

	/**
	 * Set the bankdata to sessionstorage
	 */
	public setBankdatenModelToStore(bankdatenModel: AppCalculatorModel, scope = ""): void {
		const applicationModel = this.getApplicationModel(scope);

		applicationModel.BankdatenModel = bankdatenModel;
		this.setCustomerModelToStore(bankdatenModel);
		this.setIbanToStore(bankdatenModel.Iban);
		this.setApplicationModel(applicationModel, scope);
	}

	public getBankdatenModelFromStore(scope = ""): AppCalculatorModel {
		const applicationModel = this.getApplicationModel(scope);
		return applicationModel.BankdatenModel;
	}

	/**
	 * Persists the provided application model.
	 */
	public setApplicationModel(applicationModel: AppApplicationModel, scope = ""): void {
		T.Utils.Store.set(this.getSessionKey(scope), applicationModel, T.Utils.Store.SESSION);
	}

	/**
	 * need default value because PersistenceService require this signature
	 */
	public getApplicationModel(scope = ""): AppApplicationModel {
		return AppApplicationModel.createFromObject(T.Utils.Store.get(this.getSessionKey(scope), T.Utils.Store.SESSION));
	}

	/**
	 * get the sessionkey depending on the requested scope
	 */
	private getSessionKey(scope: string): string {
		return scope ? BasicPersistenceService.DEFAULT_IBAN_SESSION_KEYPREFIX + scope : BasicPersistenceService.DEFAULT_IBAN_SESSION_KEYPREFIX;
	}

	/**
	 * @deprecated remove if all other applications do not use 'Iban' session scope anymore
	 */
	private setIbanToStore(iban: string): void {
		T.Utils.Store.set('Iban', iban, T.Utils.Store.SESSION);
	}

	/**
	 * @deprecated remove if all other applications do not use 'customer' session scope anymore
	 * still in use from formmembership
	 */
	private setCustomerModelToStore(bankdatenModel: AppCalculatorModel): void {
		const customer: { [key: string]: any } = T.Utils.Store.get('customer', T.Utils.Store.SESSION) || {};

		customer.Bankdaten = {
			Iban: bankdatenModel.Iban || '',
			Bic: bankdatenModel.Bic || ''
		};
		customer.HatAbweichendenKontoInhaber = !!bankdatenModel.HatAbweichendenKontoInhaber;

		if (customer.HatAbweichendenKontoInhaber) {
			customer.Bankdaten.AbwKontoInhaber = {
				Adresse: {
					StrasseHausnummer: bankdatenModel.AbwKontoInhaber.Adresse.StrasseHausnummer || '',
					Ort: bankdatenModel.AbwKontoInhaber.Adresse.Ort || '',
					Postleitzahl: bankdatenModel.AbwKontoInhaber.Adresse.Postleitzahl || ''
				},
				AnredeKennzeichen: bankdatenModel.AbwKontoInhaber.AnredeKennzeichen || '',
				Titel: bankdatenModel.AbwKontoInhaber.Titel,
				Name: bankdatenModel.AbwKontoInhaber.Name || '',
				Vorname: bankdatenModel.AbwKontoInhaber.Vorname || ''
			};
		}

		T.Utils.Store.set('customer', customer, T.Utils.Store.SESSION);
	}

}
